import { Injectable } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';

// import { AppRoutingModule } from './app-routing.module';
// import { SharedModule } from './shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { EditorModule } from '@tinymce/tinymce-angular';
import { TooltipModule } from 'primeng/tooltip';
import { ClickOutsideModule } from 'ng-click-outside';
import { FormsModule } from '@angular/forms';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { FullCalendarModule } from '@fullcalendar/angular';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
// import { ProviderModule } from '../provider/provider.module';;
import { SharedService } from '../shared/shared.service';
import { config } from '../config';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AvailabilityService {
currentUser = new BehaviorSubject('');
userTypeID:any;
constructor(public sharedService: SharedService) { }
remD = JSON.parse(localStorage.getItem('optplanner_user'));

updateUnAvailability(formData){
  this.currentUser.subscribe((res:any) =>{
    this.userTypeID = res.userType.id;
  })
  return this.sharedService.putData(config.addEditunavailability+`?userTypeId=${this.userTypeID}`,formData)
}
addUnAvailability(formData){
  this.currentUser.subscribe((res:any) =>{
    this.userTypeID = res.userType.id;
  })
  return this.sharedService.postData(config.addEditunavailability+`?userTypeId=${this.userTypeID}`,formData)
}


}
